let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9Lhq3")).then(() => parcelRequire('b9R9h'));